import { render, staticRenderFns } from "./StandappPasswordComponent.vue?vue&type=template&id=1c3cf933&"
import script from "./StandappPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./StandappPasswordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports